import { SINGLE_USER, STANDARD_BUSINESS } from '../dataAccess/accountTypes'

const endpoints = {
  [STANDARD_BUSINESS.id]: 'standard-business',
  [SINGLE_USER.id]: 'single-user'
}

const getEndpoint = (accountType) => {
  const suffix = endpoints[accountType]
  if (!suffix) {
    throw new Error(`Invalid signup account type ${accountType}`)
  }
  return `users/signup/${suffix}`
}
export default {
  beforeMount() {
    const email = this.$route.query.email
    if (email) {
      this.email = email
    }
  },
  methods: {
    async submitUserSignUp(accountType, payload) {
      try {
        const { clientInvitationId, promoCode } = this.$route.query
        const finalPayload = {
          ...payload,
          ...(clientInvitationId && { clientInvitationId }),
          ...(promoCode && { promoCode })
        }
        await this.$firePost(getEndpoint(accountType), null, finalPayload)
        this.$showSuccessbar('Welcome to Authentigate. Please login.')
        this.$emit('created')
      } catch (error) {
        const { response } = error
        if (response && response.data && response.data.message) {
          this.$showErrorbar(response.data.message)
        } else {
          this.$showErrorbar('Unable to signup. Please contact support.')
          this.$Sentry.captureException(error)
        }
      }
    }
  }
}
